(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var n = (cents / 100).toFixed(2);
    var withCommas = n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_no_decimals') return Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (key === 'amount_with_comma_separator') return n.replace('.', ',');
      return withCommas;
    });
  }

  /* smooth scroll */
  var lenis = null;
  function initLenis() {
    if (!window.Lenis || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    lenis = new window.Lenis({ duration: 1.2, smoothWheel: true, autoRaf: true });
  }

  /* reveal on scroll */
  function initReveal() {
    var els = $$('[data-reveal]');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.1 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* hero 3D tilt + parallax */
  function initHero() {
    var hero = $('[data-hero]'); if (!hero) return;
    var tilt = $('[data-tilt]', hero), text = $('[data-hero-text]', hero);
    var rx = 0, ry = 0, tx = 0, ty = 0, sy = 0;
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      ty = ((e.clientX - r.left) / r.width - 0.5) * 20;
      tx = -((e.clientY - r.top) / r.height - 0.5) * 16;
    });
    hero.addEventListener('mouseleave', function () { tx = 0; ty = 0; });
    (function loop() {
      rx += (tx - rx) * 0.08; ry += (ty - ry) * 0.08;
      var p = Math.min(Math.max(window.scrollY / hero.offsetHeight, 0), 1);
      sy = p;
      if (tilt) tilt.style.transform = 'translateY(' + (sy * 120) + 'px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg)';
      if (text) text.style.transform = 'translateY(' + (-sy * 80) + 'px)';
      requestAnimationFrame(loop);
    })();
  }

  /* monthly pick countdown (ends at the end of the current month) */
  function initCountdown() {
    var el = $('[data-pick-countdown]'); if (!el) return;
    var txt = $('[data-pick-countdown-text]', el);
    function update() {
      var now = new Date(), end = new Date(now.getFullYear(), now.getMonth() + 1, 1);
      var d = Math.ceil((end - now) / 86400000);
      txt.textContent = d <= 1 ? 'Pick ends today' : 'Pick ends in ' + d + ' days';
      el.hidden = false;
    }
    update(); setInterval(update, 60000);
  }

  /* full-screen site menu with homepage section links */
  function initMenu() {
    var btn = $('[data-menu-toggle]'), nav = $('[data-mobile-nav]');
    if (!btn || !nav) return;
    function setOpen(open) {
      nav.classList.toggle('is-open', open);
      nav.setAttribute('aria-hidden', open ? 'false' : 'true');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (lenis) { if (open) lenis.stop(); else lenis.start(); }
    }
    btn.addEventListener('click', function () { setOpen(true); });
    $$('[data-menu-close]', nav).forEach(function (b) { b.addEventListener('click', function () { setOpen(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setOpen(false); });
    $$('[data-menu-link]', nav).forEach(function (a) {
      a.addEventListener('click', function (e) {
        var url = new URL(a.href, window.location.href);
        setOpen(false);
        if (url.pathname === window.location.pathname && url.hash) {
          var target = document.getElementById(url.hash.slice(1));
          if (!target) return;
          e.preventDefault();
          setTimeout(function () {
            if (lenis) lenis.scrollTo(target, { offset: url.hash === '#top' ? 0 : -64 });
            else target.scrollIntoView({ behavior: 'smooth' });
          }, 300);
        }
      });
    });
  }

  /* cart drawer */
  var drawer;
  function openCart() { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); if (lenis) lenis.stop(); }
  function closeCart() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); if (lenis) lenis.start(); }

  function renderCart(cart) {
    var list = $('[data-cart-items]');
    drawer.classList.toggle('is-empty', cart.item_count === 0);
    $$('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; });
    $('[data-cart-total]').textContent = money(cart.total_price);
    $('[data-cart-checkout]').disabled = cart.item_count === 0;
    list.innerHTML = cart.items.map(function (it, i) {
      var variant = it.variant_title && !it.product_has_only_default_variant ? '<p class="mono small muted">' + it.variant_title + '</p>' : '';
      var img = it.image ? '<img class="plate__img" src="' + it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="">' : '';
      return '<li class="cart-line"><a href="' + it.url + '" class="plate cart-line__img">' + img + '</a>' +
        '<div class="cart-line__info"><a href="' + it.url + '" class="cart-line__title">' + it.product_title + '</a>' + variant +
        '<div class="cart-line__row"><div class="qty qty--sm">' +
        '<button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/></svg></button>' +
        '<input value="' + it.quantity + '" readonly aria-label="Quantity">' +
        '<button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg></button>' +
        '</div><span class="mono brass">' + money(it.final_line_price) + '</span></div></div></li>';
    }).join('');
  }

  function fetchCart() {
    return fetch(window.theme.routes.cart + '.js').then(function (r) { return r.json(); }).then(renderCart);
  }

  function addToCart(id, qty) {
    return fetch(window.theme.routes.cartAdd + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(qty) || 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(fetchCart).then(function () {
        openCart();
        $$('.cart-btn').forEach(function (b) { b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump'); });
      })
      .catch(function (err) { alert((err && (err.description || err.message)) || 'Could not add to cart.'); });
  }

  function initCart() {
    drawer = $('[data-cart-drawer]'); if (!drawer) return;
    $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); fetchCart().then(openCart); }); });
    $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

    drawer.addEventListener('click', function (e) {
      var b = e.target.closest('[data-line]'); if (!b) return;
      fetch(window.theme.routes.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(b.dataset.line), quantity: Number(b.dataset.q) })
      }).then(function (r) { return r.json(); }).then(renderCart);
    });

    document.addEventListener('click', function (e) {
      var q = e.target.closest('[data-quick-add]'); if (!q) return;
      e.preventDefault(); addToCart(q.dataset.quickAdd, 1);
    });

    $$('[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart($('[data-variant-id]', form).value, ($('[data-qty]', form) || {}).value);
      });
    });
    fetchCart();
  }

  /* product page: variants, gallery, qty */
  function initProduct() {
    var sec = $('[data-product-section]'); if (!sec) return;
    var main = $('[data-gallery-main]', sec);
    function swap(src) { if (!main || !src) return; main.style.opacity = 0; setTimeout(function () { main.removeAttribute('srcset'); main.src = src; main.style.opacity = 1; }, 200); }

    $$('[data-thumb]', sec).forEach(function (t) {
      t.addEventListener('click', function () {
        $$('[data-thumb]', sec).forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active'); swap(t.dataset.thumb);
      });
    });

    $$('[data-qty-step]', sec).forEach(function (b) {
      b.addEventListener('click', function () {
        var i = $('[data-qty]', sec); i.value = Math.max(1, (Number(i.value) || 1) + Number(b.dataset.qtyStep));
      });
    });

    var vsel = $('[data-variant-select]', sec);
    if (vsel) vsel.addEventListener('change', function () {
      var o = vsel.options[vsel.selectedIndex];
      $('[data-variant-id]', sec).value = o.value;
      $('[data-price]', sec).textContent = o.dataset.vprice;
      $('[data-compare]', sec).textContent = o.dataset.vcompare;
      var add = $('[data-add-btn]', sec), ok = o.dataset.vavailable === 'true';
      add.disabled = !ok; add.textContent = ok ? 'Add to cart' : 'Sold out';
      if (o.dataset.vimage) {
        swap(o.dataset.vimage);
        $$('[data-thumb]', sec).forEach(function (t) { t.classList.toggle('is-active', t.dataset.mediaId === o.dataset.vmedia); });
      }
      var url = new URL(window.location.href); url.searchParams.set('variant', o.value);
      window.history.replaceState({}, '', url.toString());
    });

    var rec = $('[data-recommendations]');
    if (rec) {
      fetch(rec.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh) { rec.innerHTML = fresh.innerHTML; $$('[data-reveal]', rec).forEach(function (e) { e.classList.add('is-in'); }); }
      });
    }
  }

  /* swatch hover: preview the matching color photo on the card */
  function initSwatchPreview() {
    function card(el) { return el.closest('.product-card'); }
    function show(sw) {
      var c = card(sw), media = c && $('.product-card__media', c);
      if (!media || !sw.dataset.preview) return;
      var layer = $('.swatch-preview', media);
      if (!layer) { layer = document.createElement('div'); layer.className = 'swatch-preview'; layer.innerHTML = '<img alt="">'; media.appendChild(layer); }
      $('img', layer).src = sw.dataset.preview;
      layer.classList.add('is-on');
      $$('.swatch', c).forEach(function (s) { s.classList.toggle('is-active', s === sw); });
    }
    function hide(c) {
      var layer = $('.swatch-preview', c); if (layer) layer.classList.remove('is-on');
      $$('.swatch', c).forEach(function (s) { s.classList.remove('is-active'); });
    }
    document.addEventListener('mouseover', function (e) { var sw = e.target.closest && e.target.closest('.swatch[data-preview]'); if (sw) show(sw); });
    document.addEventListener('focusin', function (e) { var sw = e.target.closest && e.target.closest('.swatch[data-preview]'); if (sw) show(sw); });
    document.addEventListener('mouseout', function (e) {
      var c = e.target.closest && e.target.closest('.product-card');
      if (c && !c.contains(e.relatedTarget)) hide(c);
    });
  }

  /* collection sort + filters (native Shopify storefront filtering) */
  function initCollection() {
    var sort = $('[data-sort]');
    if (sort) sort.addEventListener('change', function () { $('[data-sort-form]').submit(); });
    $$('[data-filter-input]').forEach(function (i) { i.addEventListener('change', function () { $('[data-filter-form]').submit(); }); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initLenis(); initReveal(); initHero(); initCountdown(); initMenu(); initCart(); initProduct(); initSwatchPreview(); initCollection();
  });
})();
